import {enGB, enUS} from 'date-fns/locale';

const localeMap = {
  'en-GB': enGB,
  'en-US': enUS,
};

export default localeMap;
